import { MeterBarChartThresholdIndicator } from '../MeterBarChartThresholdIndicator.js';
import { thresholdContainer } from './MeterBarChartThresholds.sty.js';
import { THRESHOLD_ADDITIONAL_HEIGHT } from '../../constants.js';

interface MeterBarChartThresholdsProps {
  thresholdIndicators: number[];
  segmentHeight: number;
}

export const MeterBarChartThresholds = ({
  thresholdIndicators,
  segmentHeight,
}: MeterBarChartThresholdsProps) => {
  return (
    <svg
      role="presentation"
      className={thresholdContainer}
      height={segmentHeight + THRESHOLD_ADDITIONAL_HEIGHT}
    >
      {thresholdIndicators.map((thresholdIndicator) => (
        <MeterBarChartThresholdIndicator
          key={`indicator-${thresholdIndicator}`}
          position={thresholdIndicator}
        />
      ))}
    </svg>
  );
};
